import createContext from '@ant-design/create-react-context';
var MenuContext = createContext({
  inlineCollapsed: false
});
export default MenuContext;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/menu/MenuContext.js
// module id = 187
// module chunks = 0